module.exports = __webpack_public_path__ + "img/landing_page.f2a2d691.jpg";